"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectFirstItem = void 0;
var getObjectFirstItem = function (collection) {
    if (collection) {
        var keys = Object.keys(collection);
        if (keys) {
            return {
                item: collection[keys[0]],
                key: keys[0],
            };
        }
    }
    return {
        item: undefined,
        key: undefined,
    };
};
exports.getObjectFirstItem = getObjectFirstItem;
